<script setup lang="ts">
const { getTranslation } = useLanguage();
const { main: { media: { title, cards } } } = getTranslation();
</script>

<template>
  <section class="bg-jungle-50 pt-8 pb-16 xs:pt-15 xs:pb-25">
    <CommonContainer>
      <div class="flex justify-start xs:pr-40 sm:pr-[14.375rem]">
        <h2 class="text-viola-600 font-semibold leading-default text-4xl 2xs:text-6xl sm:text-7xl hd:text-heading-xl">
          {{ title.base }}
        </h2>
      </div>

      <div class="mt-8 grid grid-cols-2 2xs:grid-cols-3 gap-8 xs:grid-cols-[repeat(6,auto)] xs:gap-4 xs:mt-14">
        <div
          v-for="({ image }, idx) in cards"
          :key="idx"
          class="max-h-17.5 flex justify-center 4k:max-h-24"
        >
          <NuxtImg
            class="h-full object-contain"
            :src="image"
          />
        </div>
      </div>
    </CommonContainer>
  </section>
</template>
